<template>
  <div class="header" ref="header">
    <div class="header-title" :style="{ width:width+'px' }">
      <div class="left" v-if="isLeftIcon" @click="$emit('back')">
        <i class="el-icon-arrow-left"></i>
      </div>
      {{ title }}
      <div class="right" @click="$emit('closeBtn')" v-if="isRightIcon">
        <i class="el-icon-close"></i>
      </div>
    </div>

    <div class="occupy"></div>
  </div>
</template>
<script>
export default {
  props: ["title", "isLeftIcon","isRightIcon"],
  data() {
    return {
      width: null,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.width = this.$refs.header.clientWidth;
      console.log(this.width);
    });
  },
};
</script>
<style lang="less" scoped>
.header {
  width: 100%;
  .header-title {
    height: 40px;
    // width: 100%;
    position: fixed;
    margin-top: 0;
    color: #ffffff;
    background: #428ff8;
    z-index: 999;
    box-sizing: border-box;
    font-size: 18px;
    font-weight: 500;
    margin: 0;
    line-height: 40px;
    text-align: center;
    .left {
      position: absolute;
      top: 0;
      left: 20px;
      .el-icon-arrow-left {
        font-size: 24px;
      }
    }
    .right {
      position: absolute;
      top: 0;
      right: 20px;
      .el-icon-close {
        font-size: 24px;
      }
    }
  }
}

.occupy {
  height: 40px;
}
</style>